












import { Component, Mixins, Prop } from "vue-property-decorator";
import CircleSelectObject from "../../../document/editor/objects/CircleSelectObject.vue";
import InputMethodSelector from "./InputMethodSelector.vue";

@Component({
  components: {
    InputMethodSelector,
  }
})
export default class CircleSelectInputMethodSelector extends Mixins() {
  @Prop()
  source: CircleSelectObject;

  get optionSet(): boolean[] {
    if (this.source.isEditDisabledByRuleSet) {
      return [];
    }
    return this.source.editingSource.isInputableFromScreen
      ? [ true, false ]
      : [];
  }

  get unselection(): boolean {
    return null;
  }

  displayTexts: { key: boolean, text: string }[] = [
    { key: false, text: "データ選択" },
    { key: true, text: "フリー入力" },
  ];
}
